import galleryService from 'common/util/galleryService';

export default () => Component(function ($context) {
	return $context.select('.product-reviews-images');
}, function ($reviews_images, self) {
	$.extend(self, {
		id: $reviews_images.data('id'),
		initEventListeners: function () {
			galleryService.onListOpen('.product-reviews-images__image', '.product-reviews-images', '.product-reviews-images__image img', 'data-zoom');

			$(window).on('resize', self.toggleOveflowedImages);
		},
		toggleOveflowedImages: function() {
			const blockWidth = $reviews_images.width();
			const $images = self.getImages();
			let $lastVisibleItem = undefined;
			let hiddenItemsCount = 0;
			let commonWidth = 0;

			$reviews_images.find('.product-reviews-images__more-count').remove();

			$images.each(function() {
				const $image = $(this);
				const imageWidth = $image.outerWidth()  + parseFloat($image.css('margin-right'));
				commonWidth += imageWidth;

				if (commonWidth > blockWidth) {
					hiddenItemsCount += 1;
				} else {
					$lastVisibleItem = $image;
				}

				$image.toggleClass('product-reviews-images__image--hidden', commonWidth > blockWidth);
			});

			if (hiddenItemsCount > 0) {
				$lastVisibleItem.append(
					'<span class="product-reviews-images__more-count">+' + hiddenItemsCount + '</span>');
			}
		},
		getImages: function () {
			return $reviews_images.find('.product-reviews-images__image');
		}
	});

	self.initEventListeners();
	self.toggleOveflowedImages();
});



